module.exports = __webpack_public_path__ + "img/pdf_vkb_logo.1fa3a68.svg";